import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource } from 'kea-resource';

const controller = rpcController("FacturacionOnline");

export const FacturacionOnline = cacheResource({

    /**Obtiene información de una guia dado su folio y clave de cliente */
    ObtenerGuiasAFacturarOnline: async (folioGuia: string, claveCliente: number): Promise<models.GuiaDTO[]> => await controller('ObtenerGuiasAFacturarOnline', { folioGuia, claveCliente }),

    /**Obtiene el id de la factura en que se encuentra facturada la guía referenciada */
    ObtenerFacturaGuia: async (folioGuia: string, claveCliente: number): Promise<models.FacturaDto> => await controller('ObtenerFacturaGuia', { folioGuia, claveCliente }),

    /**Obtiene una FacturaOnlineDTO para la visualización del cliente que quiere facturar la guía*/
    ObtenerInformacionGuiaFacturacionOnline: async (folioGuia: string, claveCliente: number): Promise<models.FacturaOnlineDTO> => await controller('ObtenerInformacionGuiaFacturacionOnline', { folioGuia, claveCliente }),


    /**Timbrar una factura desde el modulo facturación online */
    TimbrarFacturaOnline: async (id: number): Promise<void> => await controller('TimbrarFacturaOnline', { id }),



}, {
        ObtenerInformacionGuiaFacturacionOnline: true
    }, {
    });




// WEBPACK FOOTER //
// ./app/resources/items/facturaciononline.tsx